import React from "react";

import classNames from "classnames";
import { Button } from "ii-ui-kit";

import { LayoutWrapper } from "../layout-wrapper/layout-wrapper";

import { ReactComponent as LogoIcon } from "./images/logo.svg";

import "./header.scss";

interface IProps {
  className?: string;
}

export const Header: React.FC<IProps> = ({ className }) => {
  const handleButtonClick = () => {
    window.location.replace("https://www.ingosinvest.ru/");
  };

  return (
    <header className={classNames(className, "header")}>
      <LayoutWrapper className={"header__content"}>
        <div className="header__logo">
          <LogoIcon />
        </div>
        <Button
          color={"ghost"}
          size={"s"}
          onClick={handleButtonClick}
          title={"Выйти"}
        />
      </LayoutWrapper>
    </header>
  );
};
